import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import MessageNotificationConstants from '../../../constants/messageNotificationConstants'
import * as MessageActions from '../../../actions/messages';


const  FooterLink = (props) => {

  const {
    dispatch,
    to,
    title,
    className,
    current,
    highlightAlso,
  } = props;

  const classes = classnames('fl-ico fl-ico-2x', className);
  const onClick = to === MessageNotificationConstants.messagesPathName? 
              () => {
                dispatch(MessageActions.clearNotification());
              }:
              ()=>{};


  const liClass = classnames(
    'footer-menu__item',
    (current === to || current === highlightAlso) && 'active',
    (to === MessageNotificationConstants.messagesPathName && props.messagesChanged) && 'notifying'
  );

  return (
    <li className={liClass} data-name={title.toLowerCase()} onClick={onClick}>
      <Link to={to} title={title}>
        <i className={classes} />
        <span className="u-visually-hidden">{title}</span>
      </Link>
    </li>
  );
}

FooterLink.propTypes = {
  className: PropTypes.string,
  current: PropTypes.string.isRequired,
  highlightAlso: PropTypes.string,
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

FooterLink.defaultProps = {
  className: undefined,
  highlightAlso: undefined,
};

const mapStateToProps = ({
  messages: { isChanged },
}) => ({
  messagesChanged: isChanged
});

export default connect(mapStateToProps)(FooterLink);